import RescueReasonsResource from "./rescueReasons.resource";

const rescueReasonsModule = angular
  .module("app.resources.rescueReasons", [])
  .service("RescueReasons", RescueReasonsResource);

export default rescueReasonsModule;



// WEBPACK FOOTER //
// ./src/resources/rescueReasons/rescueReasons.module.js